export default function onceDetaches(el, callback) {
  const observer = new MutationObserver(onMutation)
  const ancestors = collectAncestors(el)

  for (const ancestor of ancestors) {
    observer.observe(ancestor, { childList: true })
  }

  return { destroy }

  function destroy() {
    observer.disconnect()
  }

  function onMutation(entries) {
    for (const { target, removedNodes } of entries) {
      if (removedNodes.length !== 0 && !target.contains(el)) {
        destroy()
        callback(el)
      }
    }
  }
}

function collectAncestors(el) {
  const ancestors = []

  let curr = el.parentElement
  while (curr) {
    ancestors.push(curr)
    curr = curr.parentElement
  }

  return ancestors
}
